import type { NavApi } from "../../shell/router";
import { Tab, Tabs, T } from "@v0y4ge/jrni-ui";
import { useT, t as i18nT } from "../../lib/i18n";

/**
 * Tickets section navigation. Tickets is a tab under the Events rail — the
 * ticket screens render the shared eventsSectionTabs (Tickets active) as their
 * PRIMARY nav, then this secondary subtab row for Ticket Types · Ticket Groups.
 */
export function ticketsTabs(nav: NavApi, typesCount: number, groupsCount: number) {
  return [
    { id: "types",  label: i18nT("tickets.subtabs.ticketTypes", "Ticket Types"),  count: typesCount,  onClick: () => nav.go("ticket-types") },
    { id: "groups", label: i18nT("tickets.subtabs.ticketGroups", "Ticket Groups"), count: groupsCount, onClick: () => nav.go("ticket-groups") },
  ];
}

/** Secondary subtab row shown beneath the primary Events tabs on ticket screens. */
export function TicketsSubTabs({ nav, active, typesCount, groupsCount }: { nav: NavApi; active: "types" | "groups"; typesCount: number; groupsCount: number }) {
  const t = useT();
  const tabs = ticketsTabs(nav, typesCount, groupsCount);
  return (
    <Tabs value={active} onChange={() => { /* each tab owns its own nav.onClick */ }} variant="pill" aria-label={t("tickets.subtabs.ticketsSubsections", "Tickets subsections")} style={{ padding: "12px 24px 0", background: T.canvas, flexShrink: 0 }}>
      {tabs.map((tb) => (
        <Tab key={tb.id} value={tb.id} active={tb.id === active} count={tb.count} onClick={tb.onClick}>{tb.label}</Tab>
      ))}
    </Tabs>
  );
}
